// extracted by mini-css-extract-plugin
module.exports = {"section":"style-module--section--29jEA","section__content_text":"style-module--section__content_text--jptIi"};